import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';

const FRUGA_TAB_NAMES: { [key: string]: string } = {
  "Dashboard": "Dashboard",
  "AI Agents": "AI Agents",
  "Manage Team": "Manage Team",
  "Edit AI Agent": "Edit Agent",
  "Train Your Agent": "Train Agent",
  "Products": "Products",
  "Knowledge Base": "Knowledge Base",
  "AI Include": "AI Include",
  "Pipeline": "Pipeline",
  "Channels": "Channels",
  "Contacts": "Contacts",
  "WhatsApp": "WhatsApp",
  "Chats": "Chats",
  "Templates": "Templates",
  "Broadcast List": "Broadcast List",
  "Broadcast": "Broadcast",
  "API Settings": "API Settings",
  "My Subscription": "Subscription",
  "Instagram": "Instagram",
  "Campaign Tracking": "Campaign Tracking",
  "Lead Manager": "Lead Manager",
  "Automation": "Automation",
  "Task Manage": "Task Manage"
};

const DEFAULT_TAB_NAMES: { [key: string]: string } = {
  "Dashboard": "Dashboard",
  "AI Agents": "AI Agents",
  "Manage Team": "Manage Team",
  "Edit AI Agent": "Edit AI Agent",
  "Train Your Agent": "Train Your Agent",
  "Products": "Products",
  "Knowledge Base": "Knowledge Base",
  "AI Include": "AI Include",
  "Pipeline": "Pipeline",
  "Channels": "Channels",
  "Contacts": "Contacts",
  "WhatsApp": "WhatsApp",
  "Chats": "Chats",
  "Templates": "Templates",
  "Broadcast List": "Broadcast List",
  "Broadcast": "Broadcast",
  "API Settings": "API Settings",
  "My Subscription": "My Subscription",
  "Instagram": "Instagram",
  "Campaign Tracking": "Campaign Tracking",
  "Lead Manager": "Lead Manager",
  "Automation": "Automation",
  "Task Manage": "Task Manage"
};

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  protected title = 'nexchat-enterprise';
  private observer: MutationObserver | null = null;

  constructor(private router: Router) {}

  ngOnInit() {
    this.applyFrugaTheme();
    this.setupMutationObserver();
    
    // Check periodically for changes in user login / configuration state
    setInterval(() => {
      this.applyFrugaTheme();
    }, 2000);
  }

  private setupMutationObserver() {
    if (typeof document === 'undefined') return;

    this.applyTabTranslations();

    this.observer = new MutationObserver(() => {
      // Temporarily disconnect observer to prevent recursion loops during DOM writes
      this.observer?.disconnect();
      this.applyTabTranslations();
      this.observer?.observe(document.body, { childList: true, subtree: true });
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  private applyFrugaTheme() {
    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const orgName = userData?.organization?.name || userData?.organization_name || userData?.name || '';
      
      const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
      const href = typeof window !== 'undefined' ? window.location.href : '';
      const isFrugaSubdomain = hostname.toLowerCase().includes('fruga') || href.toLowerCase().includes('fruga');
      const isFrugaLocal = localStorage.getItem('theme-fruga') === 'true';
      const isDevEnv = hostname.includes('localhost') || hostname.includes('devtunnels.ms');

      if (orgName.toLowerCase().includes('fruga') || isFrugaSubdomain || isFrugaLocal || isDevEnv) {
        document.body.classList.add('theme-fruga');
      } else {
        document.body.classList.remove('theme-fruga');
      }
    } catch (e) {
      // Ignore JSON parsing exceptions during bootstrap
    }
  }

  private applyTabTranslations() {
    try {
      const isFruga = document.body.classList.contains('theme-fruga');
      const map = isFruga ? FRUGA_TAB_NAMES : DEFAULT_TAB_NAMES;
      
      // 1. Translate Sidebar labels
      const labels = document.querySelectorAll('.nav-label');
      labels.forEach((el: any) => {
        const text = el.textContent?.trim();
        if (text && map[text] && el.textContent !== map[text]) {
          el.textContent = map[text];
        }
      });

      // 2. Translate Sidebar section headers
      const sectionHeaders = document.querySelectorAll('.nav-section .section-header span');
      sectionHeaders.forEach((el: any) => {
        const text = el.textContent?.trim();
        if (text) {
          if (isFruga && text === 'Agent Features' && el.textContent !== 'Fruga Features') {
            el.textContent = 'Fruga Features';
          } else if (!isFruga && text === 'Fruga Features' && el.textContent !== 'Agent Features') {
            el.textContent = 'Agent Features';
          }
        }
      });

      // 3. Translate brand name "NexChat" to "Brainbots"
      const logoTexts = document.querySelectorAll('.logo-text');
      logoTexts.forEach((el: any) => {
        if (el.textContent?.trim() === 'NexChat') {
          el.textContent = 'Brainbots';
        }
      });
    } catch (e) {
      // Ignore errors
    }
  }
}
